export const selectStyles = {
  containerStyle: {
    position: "relative",
    margin: "0 8px",
    fontSize: "1em",
    fontWeight: "300",
    lineHeight: "2.8em",
    cursor: "pointer",
    display: "inline-block"
  },
  hintTextStyle: {
    color: "#aeaeae",
    paddingRight: "1.5em"
  },
  valueStyle: {
    color: "#ed135d"
  },
  iconStyle: {
    position: "absolute",
    top: "50%",
    right: "2px",
    fontSize: "1em",
    marginTop: "-0.4em"
  },
  bottomLineStyle: {
    display: "block",
    width: "100%",
    height: "1px",
    position: "absolute",
    bottom: "0.42em",
    background: "#aeaeae"
  }
};

export const textFieldStyles = {
  containerStyle: {
    position: "relative",
    width: "100%",
    display: "inline-block"
  },
  style: {
    width: "100%"
  },
  errorStyle: {},
  inputStyle: {
    color: "#555"
  },
  floatingLabelStyle: {
    color: "#ccc"
  },
  underlineStyle: {},
  underlineFocusStyle: {
    borderColor: "#ed135d"
  },
  errorIconStyle: {
    fontSize: "12px",
    verticalAlign: "bottom",
    fontWeight: "700"
  },
  validIconStyle: {
    fontSize: "24px",
    position: "absolute",
    right: "0",
    top: "50%",
    marginTop: "0",
    color: "#009600"
  }
};

export const optionStyles = {
  style: {
    fontSize: "1em",
    lineHeight: "1.5em",
    padding: ".5em 0",
    fontWeight: "300",
    color: "#ed135d"
  },
  innerDivStyle: {
    padding: "0 2em 0 1em"
  },
  tickIconStyle: {
    right: "0.5em",
    top: "50%",
    margin: "-0.5em 0 0",
    fontSize: "1em"
  }
};

export const textButtonStyles = {
  containerStyle: {
    position: "relative",
    margin: "0 8px",
    fontSize: "1em",
    fontWeight: "300",
    lineHeight: "2.8em",
    cursor: "pointer",
    display: "inline-block"
  },
  hintTextStyle: {
    color: "#aeaeae"
  },
  valueStyle: {
    color: "#ed135d"
  },
  bottomLineStyle: {
    display: "block",
    width: "100%",
    height: "1px",
    position: "absolute",
    bottom: "0.42em",
    background: "#aeaeae"
  }
};

export const spinnerStyles = {
  spinnerStyle: {
    position: "fixed",
    left: "50%",
    top: "50%",
    marginLeft: "-33px",
    marginTop: "-33px"
  },
  spinnerColor: "#ed135d"
};



// WEBPACK FOOTER //
// ./src/modules/BookingPortal/components/Shared/styles/style.js